function TabOrder(items, order) {
    if (!Array.isArray(order) || order.length === 0) {
        return items;
    }

    const position = new Map(order.map((id, index) => [id, index]));

    return [...items].sort((a, b) => {
        const posA = position.get(a.id) ?? Infinity;
        const posB = position.get(b.id) ?? Infinity;

        if (posA === posB) return 0;
        return posA - posB;
    });
}

export default TabOrder;
